import React from "react";
import AOS from "aos";
import contactUsBg from "../../Assets/contactUsBg.svg";
import { useState, useEffect, useRef } from "react";
import "./ContactForm.css";
import { CheckCircleFill } from "react-bootstrap-icons";
import emailjs from "@emailjs/browser";

const style = {
  inputStyle: `col-12 my-0 my-md-2 rounded border-0 form-control px-3 py-2  mb-2 mb-md-1 was-validated`,
};

const formText = {
  maxWidth: 400,
};

const formStyle = {
  position: "absolute",
  top: "10%",
};

const dataStyle = {
  color: "rgba(128, 128, 128, 1)",
  padding: "0.5rem 1rem",
  fontSize: "1.1rem",
};

const ContactForm = () => {
  useEffect(() => {
    AOS.init({ duration: 1500 });
  }, []);

  const form = useRef();
  const [validation, setValidation] = useState(false);
  const [closeNotification, setCloseNotification] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_6eavg89",
        "template_ecwhelb",
        form.current,
        "4CsIOrBL6Z1eB9p4O"
      )
      .then(
        (result) => {
          console.log(result.text);
          if (result.status === 200) {
            setValidation(!validation);
            setCloseNotification(!closeNotification);
          }
        },
        (error) => {
          console.log(error.text);
        }
      );

    e.target.reset();
  };
  return (
    <div id="contactUs" className="position-relative" data-aos="fade-up">
      <img
        style={{ width: "100%", objectFit: "cover", height: "40rem" }}
        src={contactUsBg}
        loading="lazy"
        alt="logo"
      />
      <div className="position-absolute top-0 start-0 w-100 bg-dark h-100 opacity-50"></div>
      <div
        className="position-absolute text-center text-white w-100"
        style={formStyle}
      >
        <h3 className="display-5 fw-bold">Get a Quote</h3>
        <div className=" mx-auto text-center" style={formText}>
          <p className="lead px-2 px-md-0">
            Find out about the costs of getting our products
          </p>
        </div>
        <form
          ref={form}
          className="container px-3 px-sm-4 my-4 mx-auto needs-validation form-width"
          onSubmit={sendEmail}
        >
          <div className="row">
            <div className="col-12 col-md-6 form-group">
              <input
                className={style.inputStyle}
                type="text"
                required
                style={dataStyle}
                placeholder="Name"
                name="user_name"
              />

              <input
                className={style.inputStyle}
                type="text"
                style={dataStyle}
                required
                placeholder="Company"
                name="user_company"
                value="Logistat"
                disabled
              />
            </div>
            <div className="col-12 col-md-6">
              <input
                className={style.inputStyle}
                type="email"
                style={dataStyle}
                required
                placeholder="Email"
                name="user_email"
              />

              <input
                className={style.inputStyle}
                type="text"
                style={dataStyle}
                required
                placeholder="Phone Number"
                name="user_phone"
              />
            </div>

            <div className="form-group">
              <textarea
                className="col-12 rounded mt-2 form-control"
                type="text"
                style={dataStyle}
                required
                rows="4"
                placeholder="Description"
                name="user_message"
              />
              <button
                className="btn my-3 py-2 mx-auto border-0 w-100 fs-5"
                style={{
                  backgroundColor: "rgba(40, 182, 114, 1)",
                  color: "white",
                  fontSize: "1.07rem",
                }}
                onSubmit={sendEmail}
              >
                Submit
              </button>
            </div>

            <div className="validation">
              {validation && closeNotification ? (
                <div className="success">
                  <div className="bg-white d-flex justify-content-between py-3 px-4 rounded align-items-center">
                    <div>
                      <CheckCircleFill />
                    </div>
                    <small>Message sent</small>

                    <button
                      type="button"
                      className=" btn my-0 btn-sm text-white"
                      style={{ background: "rgb(165, 99, 99)" }}
                      onClick={() => {
                        setCloseNotification(!closeNotification);
                      }}
                    >
                      Close
                    </button>
                  </div>
                </div>
              ) : (
                <div className="error ">some error</div>
              )}
              {}
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ContactForm;
